module.exports = __webpack_public_path__ + "static/media/logoAlt.975d8a54.png";